import { GraphQLEditor, GraphQLEditorProps } from '@components/graphql-editor';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormGraphQLEditorProps<T = unknown> = FormFieldProps<GraphQLEditorProps, T>;

export function FormGraphQLEditor<T>(props: FormGraphQLEditorProps<T>) {
  const formFieldProps = useFormField(props);

  return <GraphQLEditor {...props} {...formFieldProps} />;
}
